export const TYPE_SUMMARY = 'summary';
export const TYPE_DETAILED = 'detailed';
